module.exports = __webpack_public_path__ + "img/mnms-verano.1e04920d.png";